import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface SupportStrategiesSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Use a calm, supportive voice to guide through problem-solving",
  "Offer a sensory tool or movement break",
  "Give space and reduce direct demands, using non-verbal cues",
  'Offer a break or "quiet task" to reduce pressure',
  "Break the task into smaller steps and reduce distractions",
  "Prompt the use of calming strategies such as a calming corner or squeeze ball",
  "Validate feelings and reduce demands temporarily, offering choice",
  "Offer noise-cancelling headphones or calm space",
  "Assign a purposeful errand, e.g. run a message to neighbouring class",
  "Gently encourage use of known self-calming strategies",
  'Encourage use of "break pass" for student to have a controlled break',
  "Validate feelings and remain patient and empathetic",
];

export const SupportStrategiesSection: React.FC<
  SupportStrategiesSectionProps
> = ({ values, otherValue, onCheckboxChange, onOtherChange, className }) => (
  <CollapsibleFormSection
    title="Select/describe appropriate staff responses for the student at this stage:"
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label className="other-input-label" htmlFor="supportStrategiesOther">
        Other:
      </label>
      <input
        type="text"
        id="supportStrategiesOther"
        name="supportStrategiesOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
